import { useCallback, useMemo } from 'react';
import { useReactFlow } from 'reactflow';

import type { ProcessFlowLayout } from '~/common/model/api/batch-type/process-flow';

import type { ProcessFlowHook } from './_flow.type';

/**
 * Use ProcessFlow.
 *
 * @returns {ProcessFlowHook} ProcessFlow hook.
 */
export default function useProcessFlow(): ProcessFlowHook {
  const flow = useReactFlow();

  const getLayout = useCallback<ProcessFlowHook['getLayout']>(
    () =>
      ({
        nodes: flow.getNodes(),
        edges: flow.getEdges(),
      }) as ProcessFlowLayout,
    [flow],
  );

  return useMemo<ProcessFlowHook>(
    () =>
      ({
        getLayout,

        getNodes: flow.getNodes,
        setNodes: flow.setNodes,

        getEdges: flow.getEdges,
        setEdges: flow.setEdges,

        viewPort: {
          setCenter: flow.setCenter,
        },
      }) as ProcessFlowHook,
    [flow.getEdges, flow.getNodes, flow.setCenter, flow.setEdges, flow.setNodes, getLayout],
  );
}
